<script>
    import { createEventDispatcher, onMount, beforeUpdate } from 'svelte';

    const dispatch = createEventDispatcher();

    onMount(async () => {
        feather.replace();
        dispatch('setActiveTab', {
            tabName: 'Notification'
        });
    })
</script>

Notification here